import { Component } from "@angular/core";

@Component({
	selector: "ic-unknown-problem",
	templateUrl: "./unknown-problem.component.html",
	styleUrls: ["./unknown-problem.component.scss"],
	standalone: false,
})
export class UnknownProblemComponent {}
